
export class Constants {
    public static PASSWORD_MIN_LENGTH = 12;
    public static EXPIRES_KEY = 'expires_at';
    public static REFRESHTOKEN_KEY = 'auth-refreshtoken';
    public static TOKEN_KEY = 'auth-token';
    public static USER_KEY = 'auth-user';
    public static TC = 'TALENT_CLOUD';
    public static PYT = 'PAY_YOUR_TEAM';
    public static CO = 'CREATIVE_OBJECTS';
    public static SE_INCOME_LIMIT = 2400000;
    public static PLATFORM_PROJECT_BUDGET_LIMIT = 599999;
}

export const STRIPE_COUNTRIES = [
    { name: 'AUSTRALIA', code: 'AU', default: false },
    { name: 'AUSTRIA', code: 'AT', default: false },
    { name: 'BELGIUM', code: 'BE', default: false },
    { name: 'BRAZIL', code: 'BR', default: false },
    { name: 'BULGARIA', code: 'BG', default: false },
    { name: 'CANADA', code: 'CA', default: false },
    { name: 'CYPRUS', code: 'CY', default: false },
    { name: 'CZECH REPUBLIC', code: 'CZ', default: false },
    { name: 'DENMARK', code: 'DK', default: false },
    { name: 'ESTONIA', code: 'EE', default: false },
    { name: 'FINLAND', code: 'FI', default: false },
    { name: 'FRANCE', code: 'FR', default: false },
    { name: 'GERMANY', code: 'DE', default: false },
    { name: 'GREECE', code: 'GR', default: false },
    { name: 'HONG KONG', code: 'HK', default: false },
    { name: 'INDIA', code: 'IN', default: false },
    { name: 'IRELAND', code: 'IE', default: false },
    { name: 'ITALY', code: 'IT', default: false },
    { name: 'JAPAN', code: 'JP', default: false },
    { name: 'LATVIA', code: 'LV', default: false },
    { name: 'LITHUANIA', code: 'LT', default: false },
    { name: 'LUXEMBOURG', code: 'LU', default: false },
    { name: 'MALAYSIA', code: 'MY', default: false },
    { name: 'MALTA', code: 'MT', default: false },
    { name: 'MEXICO', code: 'MX', default: false },
    { name: 'NETHERLANDS', code: 'NL', default: false },
    { name: 'NEW ZEALAND', code: 'NZ', default: false },
    { name: 'NORWAY', code: 'NO', default: false },
    { name: 'POLAND', code: 'PL', default: false },
    { name: 'PORTUGAL', code: 'PT', default: false },
    { name: 'ROMANIA', code: 'RO', default: false },
    { name: 'SINGAPORE', code: 'SG', default: false },
    { name: 'SLOVAKIA', code: 'SK', default: false },
    { name: 'SLOVENIA', code: 'SI', default: false },
    { name: 'SPAIN', code: 'ES', default: false },
    { name: 'SWEDEN', code: 'SE', default: false },
    { name: 'SWITZERLAND', code: 'CH', default: false },
    { name: 'UNITED KINGDOM', code: 'GB', default: false },
    { name: 'UNITED STATES', code: 'US', default: false },
];
